module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetMedium@2x.1012a8d.webp";